(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-entreprise"] && !Shopify.designMode) return;
  try {
    (function () {
    function setup(input) {
      if (input.dataset.placeholderInit === '1') return;
      input.dataset.placeholderInit = '1';
      var wrap = input.closest('[data-placeholder]');
      if (!wrap) return;
      function sync() { wrap.classList.toggle('has-value', !!input.value); }
      sync();
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      input.addEventListener('blur', sync);
    }
    function init() {
      document.querySelectorAll('[data-placeholder] input[type="date"]').forEach(setup);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form-mariage"] && !Shopify.designMode) return;
  try {
    (function () {
    function setup(input) {
      if (input.dataset.placeholderInit === '1') return;
      input.dataset.placeholderInit = '1';
      var wrap = input.closest('[data-placeholder]');
      if (!wrap) return;
      function sync() { wrap.classList.toggle('has-value', !!input.value); }
      sync();
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      input.addEventListener('blur', sync);
    }
    function init() {
      document.querySelectorAll('[data-placeholder] input[type="date"]').forEach(setup);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form-projet"] && !Shopify.designMode) return;
  try {
    (function () {
    function setup(input) {
      if (input.dataset.placeholderInit === '1') return;
      input.dataset.placeholderInit = '1';
      var wrap = input.closest('[data-placeholder]');
      if (!wrap) return;
      function sync() { wrap.classList.toggle('has-value', !!input.value); }
      sync();
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      input.addEventListener('blur', sync);
    }
    function init() {
      document.querySelectorAll('[data-placeholder] input[type="date"]').forEach(setup);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["logo-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function duplicateTrack(track) {
      if (track.dataset.duplicated === 'true') return;
      const items = Array.from(track.children);
      if (items.length === 0) return;
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      track.dataset.duplicated = 'true';
    }

    document.querySelectorAll('[data-logo-carousel-track]').forEach(duplicateTrack);

    // Re-run après hydratation pour les cas SPA / theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        document.querySelectorAll('[data-logo-carousel-track]').forEach(duplicateTrack);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mariage-gallery-meta"] && !Shopify.designMode) return;
  try {
    (function () {
    const galleries = document.querySelectorAll('[data-mariage-gallery]');
    galleries.forEach((gallery) => {
      const initial = parseInt(gallery.getAttribute('data-initial-visible') || '12', 10);
      const step = parseInt(gallery.getAttribute('data-load-more-step') || '20', 10);
      const colsDesktop = Math.max(1, parseInt(gallery.getAttribute('data-cols-desktop') || '3', 10));
      const grid = gallery.querySelector('[data-mariage-grid]');
      const toggle = gallery.querySelector('[data-mariage-toggle]');
      if (!grid) return;

      const items = Array.from(grid.querySelectorAll('.mariage-gallery__item'));
      items.sort((a, b) => {
        const pa = parseInt(a.getAttribute('data-position') || '0', 10);
        const pb = parseInt(b.getAttribute('data-position') || '0', 10);
        return pa - pb;
      });
      items.forEach((item) => item.remove());

      const total = items.length;
      const labelLoadMore = gallery.getAttribute('data-load-more-label') || 'Charger plus';
      const labelCollapse = gallery.getAttribute('data-collapse-label') || 'Réduire la galerie';

      let visible = Math.min(initial, total);
      let currentCols = 0;
      let gridColumns = [];

      function colCount() {
        const w = window.innerWidth;
        if (w >= 990) return colsDesktop;
        if (w >= 600) return 2;
        return 1;
      }

      function ratio(item) {
        const img = item.querySelector('img');
        if (!img) return 1;
        const w = parseFloat(img.getAttribute('width')) || 1;
        const h = parseFloat(img.getAttribute('height')) || 1;
        return h / w;
      }

      function render() {
        const cols = colCount();
        currentCols = cols;
        grid.style.maxHeight = '';
        grid.classList.add('is-columned');
        grid.textContent = '';
        const columns = [];
        const heights = [];
        for (let c = 0; c < cols; c++) {
          const col = document.createElement('div');
          col.className = 'mariage-gallery__col';
          grid.appendChild(col);
          columns.push(col);
          heights.push(0);
        }
        const shown = Math.min(visible, total);
        for (let i = 0; i < shown; i++) {
          let target = 0;
          for (let c = 1; c < cols; c++) {
            if (heights[c] < heights[target] - 0.0001) target = c;
          }
          columns[target].appendChild(items[i]);
          heights[target] += ratio(items[i]);
        }
        gridColumns = columns;
        applyClip();
      }

      function applyClip() {
        if (visible < total) {
          gallery.classList.add('is-collapsed');
          let minH = Infinity;
          gridColumns.forEach((c) => {
            const h = c.getBoundingClientRect().height;
            if (h > 0 && h < minH) minH = h;
          });
          if (isFinite(minH) && minH > 0) {
            grid.style.maxHeight = Math.round(minH) + 'px';
          }
        } else {
          gallery.classList.remove('is-collapsed');
          grid.style.maxHeight = '';
        }
      }

      function updateToggle() {
        if (!toggle) return;
        if (visible >= total) {
          toggle.textContent = labelCollapse;
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          const remaining = total - visible;
          toggle.textContent = labelLoadMore + ' · ' + remaining + ' restantes';
          toggle.setAttribute('aria-expanded', 'false');
        }
      }

      render();
      updateToggle();

      if (toggle) {
        toggle.addEventListener('click', () => {
          if (visible >= total) {
            visible = Math.min(initial, total);
            render();
            updateToggle();
            const top = gallery.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
          } else {
            visible = Math.min(total, visible + step);
            render();
            updateToggle();
          }
        });
      }

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (colCount() !== currentCols) render();
          else applyClip();
        }, 150);
      });

      window.addEventListener('load', applyClip);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["realisation-content"] && !Shopify.designMode) return;
  try {
    (function () {
    const blocks = document.querySelectorAll('.realisation-gallery');
    blocks.forEach(initBlock);

    function initBlock(block) {
      const animate = block.dataset.animate === 'true';
      const useLightbox = block.dataset.lightbox === 'true';
      const items = block.querySelectorAll('.realisation-gallery__item');
      const lightbox = block.querySelector('[data-realisation-lightbox]');

      if (animate && items.length && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('is-visible');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
        items.forEach((item) => io.observe(item));
      } else {
        items.forEach((item) => item.classList.add('is-visible'));
      }

      if (useLightbox && lightbox) initLightbox(block, lightbox);
    }

    function initLightbox(block, dialog) {
      const track = dialog.querySelector('[data-realisation-lightbox-track]');
      const slides = dialog.querySelectorAll('.realisation-gallery__lightbox-slide');
      const closeBtn = dialog.querySelector('[data-realisation-lightbox-close]');
      const prevBtn = dialog.querySelector('[data-realisation-lightbox-prev]');
      const nextBtn = dialog.querySelector('[data-realisation-lightbox-next]');
      const counter = dialog.querySelector('[data-realisation-lightbox-current]');
      const triggers = block.querySelectorAll('[data-realisation-zoom]');

      const open = (idx) => {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        scrollToIndex(idx, 'instant');
        if (counter) counter.textContent = String(idx + 1);
        document.documentElement.style.overflow = 'hidden';
      };
      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        document.documentElement.style.overflow = '';
      };
      const scrollToIndex = (idx, behavior) => {
        const slide = slides[idx];
        if (slide) slide.scrollIntoView({ behavior: behavior || 'smooth', inline: 'center', block: 'nearest' });
      };
      const currentIdx = () => {
        if (!track) return 0;
        const rect = track.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        let best = 0;
        let bestDist = Infinity;
        slides.forEach((s, i) => {
          const r = s.getBoundingClientRect();
          const c = r.left + r.width / 2;
          const dist = Math.abs(c - center);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = parseInt(trigger.dataset.index, 10) || 0;
          open(idx);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(Math.max(0, currentIdx() - 1)));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(Math.min(slides.length - 1, currentIdx() + 1)));

      dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
      dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); scrollToIndex(Math.max(0, currentIdx() - 1)); }
        if (e.key === 'ArrowRight') { e.preventDefault(); scrollToIndex(Math.min(slides.length - 1, currentIdx() + 1)); }
      });
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; });

      if (track && counter) {
        let raf = null;
        track.addEventListener('scroll', () => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => { counter.textContent = String(currentIdx() + 1); });
        }, { passive: true });
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text-collapsible"] && !Shopify.designMode) return;
  try {
    if (!window.__textCollapsibleInit) {
    window.__textCollapsibleInit = true;
    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('.text-collapsible__trigger');
      if (!trigger) return;
      const wrap = trigger.closest('.text-collapsible');
      if (!wrap) return;
      const expanded = wrap.classList.toggle('is-expanded');
      const label = trigger.querySelector('.text-collapsible__trigger-label');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        if (expanded && trigger.dataset.collapseLabel) {
          label.textContent = trigger.dataset.collapseLabel;
        } else if (!expanded && trigger.dataset.expandLabel) {
          label.textContent = trigger.dataset.expandLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
